import type { Store } from '@warp-drive/core';
import { service } from '@ember/service';
import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import type EmployeeModel from './employee.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class InviteModel extends Model {
  @service declare store: Store;

  @attr declare isActive: boolean;
  @attr declare enrollmentLink: string;
  @attr declare fromDate: string;
  @attr declare expirationDate: string;

  @belongsTo('employee', { async: false, inverse: null })
  declare user: EmployeeModel;

  get isExpired() {
    return new Date(this.expirationDate) < new Date();
  }

  [Type] = 'invite' as const;
}
